import {inject, Injectable} from '@angular/core';
import {Observable, switchMap} from "rxjs";
import {baseUrl} from "../../../../core/constants/base-url";
import {HttpClient} from "@angular/common/http";
import {productCardsResourceParams} from "../configs/product-card-page-config";
import {DetachProductCard, ProductCardData} from "../types/product-card-data.types";
import {GetDataInModalParams} from "../types/product-card-modals.types";
import {jsonPathHeaders} from "../../../../core/models/http-headers";
import {RecordUpdateRequestParams} from "../../../../core/types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCardApiService {
  private http: HttpClient = inject(HttpClient);

  public fetchProductCard(id: number): Observable<ProductCardData> {
    return this.http.get<ProductCardData>(`${baseUrl}/${productCardsResourceParams.path}/${id}`, {});
  }

  public fetchDataInModal<T>({ path, queryParams }: GetDataInModalParams): Observable<Array<T>> {
    return this.http.get<Array<T>>(`${baseUrl}/${path}`, {
      params: queryParams
    });
  }

  public detachProductCard({ marketplace, queryParams }: DetachProductCard): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${productCardsResourceParams.path}/detach/${marketplace}`, {}, { params: queryParams })
  }

  public updateProductCard({ recordId, path, value }: RecordUpdateRequestParams): Observable<ProductCardData> {
    const body = [{
      'op': 'add',
      'path': `/${path}`,
      'value': value,
    }];

    return this.http.patch<ProductCardData>(`${baseUrl}/${productCardsResourceParams.path}/${recordId}`, body, {
      headers: jsonPathHeaders
    });
  }

  public deleteProductCard(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/${productCardsResourceParams.path}/${id}`);
  }

  public fetchProductCardSyncData(productCardId: number): Observable<ProductCardData> {
    return this.http.post<void>(`${baseUrl}/${productCardsResourceParams.path}/sync-data`, {}, { params: { productCardId: productCardId } }).pipe(
      switchMap(() => this.fetchProductCard(productCardId))
    );
  }
}
